const { captchaKey } = require("./captchaToken");

function getQueryVariable(variable) {
  var query = window.location.search.substring(1),
    vars = query.split("&");
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split("=");
    if (pair[0] == variable) {
      return pair[1];
    }
  }
  return false;
}

function documentReady(fn) {
  if (document.readyState != "loading") {
    fn();
  } else {
    document.addEventListener("DOMContentLoaded", fn);
  }
}

function addRecaptchaScript() {
  return new Promise((resolve) => {
    const scriptEl = document.getElementById("grecaptcha");
    if (scriptEl) return resolve(true);

    const script = document.createElement("script");
    script.src = `https://www.google.com/recaptcha/api.js?render=${captchaKey}`;
    script.setAttribute("id", "grecaptcha");
    document.body.appendChild(script);

    script.addEventListener("load", function () {
      resolve(true);
    });
  });
}

function getRecaptchaToken() {
  return new Promise((resolve) => {
    addRecaptchaScript().then(() => {
      resolve(
        new Promise((resolve) => {
          grecaptcha.ready(function () {
            grecaptcha
              .execute(`${captchaKey}`, {
                action: "submit",
              })
              .then(function (token) {
                resolve(token);
              });
          });
        })
      );
    });
  });
}

function checkRecaptcha() {
  const endpointUrl = "/api/recaptcha/isValid/";
  return new Promise((resolve) => {
    getRecaptchaToken().then((token) => {
      fetch(endpointUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          token: token,
        }),
      })
        .then((res) => res.json())
        .then((res) => resolve(res));
    });
  });
}

exports.getQueryVariable = getQueryVariable;
exports.getRecaptchaToken = getRecaptchaToken;
exports.checkRecaptcha = checkRecaptcha;
exports.documentReady = documentReady;
